<div
  class="sharesHeaders__site"
  [class.sharesHeaders__site--error]="ppHasError"
  ppTooltip
  [ppTrimTooltip]="true"
  [ppTitle]="siteName"
>
  {{ siteName }}
</div>
